import { Coupon, Product } from '../types/Add-subscription.types';
import exactMath from 'exact-math';

interface Category {
  title: string;
  type: string[];
}

interface usePurchaseSummaryReturn {
  discount: number;
  categories: Category[];
}

interface usePurchaseSummaryProps {
  products: Product[];
  counts: Record<string, number>;
  appliedCoupon: Coupon | null;
}

const categories: Category[] = [
  { title: 'Carretera', type: ['Vehiculos', 'Motocicleta'] },
  { title: 'Hogar', type: ['Hogar'] },
  { title: 'Addons', type: ['Add-on'] },
];

export const usePurchaseSummary = ({
  appliedCoupon,
  counts,
  products,
}: usePurchaseSummaryProps): usePurchaseSummaryReturn => {
  const discount = appliedCoupon
    ? (() => {
        let totalDiscount = 0;

        // Iterate over all prices in the coupon
        appliedCoupon.price.forEach((couponPrice) => {
          const product = products.find((p) =>
            p.prices.some((price) => price.id === couponPrice.id)
          );

          if (!product) return;

          const priceObj = product.prices.find((p) => p.id === couponPrice.id);
          if (!priceObj) return;

          const count = counts[couponPrice.id] || 0;
          if (count === 0) return;

          // Calculate the subtotal for this price (price * quantity)
          const priceToUse =
            count >= priceObj.max_additional
              ? priceObj.additional_price
              : priceObj.price;
          const subtotalForPrice = priceToUse * count;

          // Apply coupon discount to the subtotal
          const calculatedDiscount = appliedCoupon.is_percent
            ? exactMath.mul(subtotalForPrice, appliedCoupon.amount / 100)
            : appliedCoupon.amount;

          totalDiscount += calculatedDiscount;
        });

        // Ensure the discount is returned with two decimal places without rounding
        return Math.floor(totalDiscount * 100) / 100;
      })()
    : 0;

  return {
    discount,
    categories,
  };
};
